export const LANGUAGES = ["RO", "EN", "DE"];

const projectIds = [
   ["horizonauto", "Horizon Auto"],
   ["stm", "STM Performance"],
   ["fruconomy", "Fruconomy"],
   ["apo", "APO"],
   ["euroaccent", "Euroaccent"],
   ["nivaspet", "Nivaspet"],
   ["daydriver", "DayDriver"],
   ["barbarosa", "Barbarosa School"],
   ["stratus", "Stratus Lofts"],
   ["glg", "Scoala Auto GLG"],
   ["seven11", "7Eleven Agency"],
   ["vapeoutlet", "Vape Outlet"],
   ["bantleads", "Bantleads"],
   ["maruldeaur", "Marul de Aur"],
   ["mambolichior", "Mambo Lichior"],
   ["noidivin", "Noi Divin"],
   ["insuladistractiilor", "Insula Distractiilor"],
   ["wuling", "Wuling"],
   ["instruireautoplatform", "Instruire Auto Platforma"],
   ["instruireautoschool", "Instruire Auto"],
];

const projectTextOverrides = {
   RO: {
      stm: {
         contribution:
            "Am lucrat la site si la identitatea vizuala, inclusiv logo, structura de prezentare, UI responsive si implementare frontend.",
      },
      seven11: {
         contribution:
            "Am realizat site-ul de prezentare, cu structura clara, interfata responsive si o experienta vizuala potrivita pentru agentie.",
      },
      instruireautoplatform: {
         summary:
            "Platforma digitala mare pentru invatare, testare, examinare si management, folosita de mii de studenti.",
         overview:
            "Platforma conecteaza pregatirea studentilor, testele, examinarea, managementul cursurilor si administrarea continutului intr-un sistem amplu.",
         contribution:
            "Am construit functionalitati de programare, testare, examinare, pregatire, management, administrare de continut si fluxuri diverse pentru o platforma folosita la scara mare.",
         challenges:
            "Provocarea a fost organizarea unui sistem complex, cu multe roluri, materiale, teste si fluxuri, astfel incat platforma sa ramana clara si usor de folosit.",
      },
      instruireautoschool: {
         contribution:
            "Am realizat site-ul de prezentare pentru scoala, cu structura clara, design responsive si informatii usor de parcurs.",
      },
      maruldeaur: {
         summary:
            "Site pentru concert si festival, construit dupa brand book si adaptat stilistic pentru identitatea Marul de Aur.",
         overview:
            "Am transpus energia vizuala a brandului intr-un site expresiv, coerent si usor de parcurs pentru public.",
         contribution:
            "Am implementat site-ul dupa brand book, pastrand stilistica, ritmul vizual si identitatea evenimentului intr-o experienta web premium.",
      },
      mambolichior: {
         overview:
            "Am construit o prezentare digitala care pastreaza caracterul brandului si il transforma intr-o experienta web clara.",
         contribution:
            "Am implementat site-ul cu atentie la stilistica brandului, structura responsive si prezentare vizuala coerenta.",
      },
      nivaspet: {
         overview:
            "Am construit o prezenta web care pastreaza identitatea brandului si o face usor de inteles pentru clienti.",
         contribution:
            "Am implementat site-ul cu focus pe stilistica brandului, claritate, responsive design si prezentarea serviciilor.",
      },
   },
   EN: {
      stm: {
         contribution:
            "We worked on the website and visual identity, including logo, presentation structure, responsive UI, and frontend implementation.",
      },
      seven11: {
         contribution:
            "We built the presentation website, with clear structure, responsive interface, and a visual experience suitable for the agency.",
      },
      instruireautoplatform: {
         summary:
            "A large digital platform for learning, testing, examination, and management, used by thousands of students.",
         overview:
            "The platform connects student preparation, tests, examinations, course management, and content administration in one broad system.",
         contribution:
            "We built scheduling, testing, examination, preparation, management, content administration, and multiple custom flows for a platform used at scale.",
         challenges:
            "The challenge was organizing a complex system with many roles, materials, tests, and flows while keeping the platform clear and easy to use.",
      },
      instruireautoschool: {
         contribution:
            "We built the school presentation website, with clear structure, responsive design, and information that is easy to navigate.",
      },
      maruldeaur: {
         summary:
            "Concert and festival website built around the brand book and adapted to the Marul de Aur visual identity.",
         overview:
            "We translated the brand energy into an expressive, coherent, and easy-to-navigate web experience.",
         contribution:
            "We implemented the website based on the brand book, preserving the visual style, rhythm, and event identity in a premium web experience.",
      },
      mambolichior: {
         overview:
            "We built a digital presentation that keeps the character of the brand and turns it into a clear web experience.",
         contribution:
            "We implemented the website with attention to brand style, responsive structure, and coherent visual presentation.",
      },
      nivaspet: {
         overview:
            "We built a web presence that keeps the brand identity and makes it easy for clients to understand.",
         contribution:
            "We implemented the website with focus on brand style, clarity, responsive design, and service presentation.",
      },
   },
   DE: {
      stm: {
         contribution:
            "Wir haben an Website und visueller Identitaet gearbeitet, inklusive Logo, Praesentationsstruktur, responsivem UI und Frontend-Umsetzung.",
      },
      seven11: {
         contribution:
            "Wir haben die Praesentationswebsite gebaut, mit klarer Struktur, responsivem Interface und passender visueller Erfahrung fuer die Agentur.",
      },
      instruireautoplatform: {
         summary:
            "Eine grosse digitale Plattform fuer Lernen, Tests, Pruefungen und Management, genutzt von tausenden Studierenden.",
         overview:
            "Die Plattform verbindet Vorbereitung, Tests, Pruefungen, Kursmanagement und Content-Administration in einem breiten System.",
         contribution:
            "Wir haben Funktionen fuer Planung, Tests, Pruefungen, Vorbereitung, Management, Content-Administration und verschiedene Custom-Flows gebaut.",
         challenges:
            "Die Herausforderung war, ein komplexes System mit vielen Rollen, Materialien, Tests und Flows klar und leicht nutzbar zu halten.",
      },
      instruireautoschool: {
         contribution:
            "Wir haben die Praesentationswebsite der Schule gebaut, mit klarer Struktur, responsivem Design und leicht auffindbaren Informationen.",
      },
      maruldeaur: {
         summary:
            "Website fuer Konzert und Festival, auf Basis des Brand Books und der visuellen Identitaet von Marul de Aur.",
         overview:
            "Wir haben die Energie der Marke in eine ausdrucksstarke, kohaerente und leicht nutzbare Web-Erfahrung uebertragen.",
         contribution:
            "Wir haben die Website nach Brand Book umgesetzt und Stilistik, visuellen Rhythmus und Event-Identitaet in einer hochwertigen Web-Erfahrung bewahrt.",
      },
      mambolichior: {
         overview:
            "Wir haben eine digitale Praesentation gebaut, die den Charakter der Marke bewahrt und in eine klare Web-Erfahrung bringt.",
         contribution:
            "Wir haben die Website mit Fokus auf Markenstil, responsive Struktur und kohaerente visuelle Praesentation umgesetzt.",
      },
      nivaspet: {
         overview:
            "Wir haben eine Web-Praesenz gebaut, die die Markenidentitaet bewahrt und fuer Kunden leicht verstaendlich macht.",
         contribution:
            "Wir haben die Website mit Fokus auf Markenstil, Klarheit, responsive Design und Service-Praesentation umgesetzt.",
      },
   },
};

const makeProjects = (lang) =>
   Object.fromEntries(
      projectIds.map(([id, title]) => [
         id,
         {
            title,
            summary:
               lang === "RO"
                  ? "Prezentare digitala construita pentru claritate, incredere si conversie."
                  : lang === "DE"
                    ? "Eine digitale Praesentation, gebaut fuer Klarheit, Vertrauen und Conversion."
                    : "A digital presentation built for clarity, trust, and conversion.",
            overview:
               lang === "RO"
                  ? "Am organizat informatia, vizualul si fluxurile principale intr-o experienta usor de parcurs."
                  : lang === "DE"
                    ? "Wir haben Informationen, Visuals und Kernablaeufe in eine klare Nutzererfahrung gebracht."
                    : "We organized information, visuals, and key flows into an experience that is easy to navigate.",
            contribution:
               lang === "RO"
                  ? "Strategie de continut, UI responsive, frontend si optimizare vizuala."
                  : lang === "DE"
                    ? "Content-Struktur, responsives UI, Frontend und visuelle Optimierung."
                    : "Content structure, responsive UI, frontend, and visual optimization.",
            challenges:
               lang === "RO"
                  ? "Provocarea a fost sa pastram experienta simpla, dar suficient de expresiva pentru brand."
                  : lang === "DE"
                    ? "Die Herausforderung war, die Erfahrung einfach und zugleich markenstark zu halten."
                    : "The challenge was keeping the experience simple while still expressive for the brand.",
            ...(projectTextOverrides[lang]?.[id] || {}),
         },
      ]),
   );

const roServices = {
   automation: {
      label: "Automatizari si fluxuri AI",
      tier: "Automatizari si fluxuri AI",
      tagline: "Automatizam procese repetitive si construim fluxuri inteligente pentru echipe.",
      hero: "Fluxuri AI care elimina munca repetitiva.",
      intro: "Construim automatizari pentru vanzari, suport, administrare, operatiuni si raportare.",
      includes: ["Fluxuri AI", "Integrari", "CRM", "Rapoarte"],
      sections: [
         { title: "Ce conectam", text: "Tool-uri, formulare, CRM-uri, email, date, notificari si rapoarte." },
         { title: "Ce optimizam", text: "Taskuri repetitive, procese manuale si blocaje intre departamente." },
         { title: "Rezultat", text: "Un sistem rapid, clar si scalabil, cu mai putin lucru manual." },
      ],
   },
   platforms: {
      label: "Platforme web personalizate",
      tier: "Platforme custom",
      tagline: "Dezvoltam CRM-uri, dashboard-uri, sisteme de programari si aplicatii business.",
      hero: "Platforme web construite pe procesele reale ale companiei.",
      intro: "Cream sisteme personalizate pentru administrare interna, clienti, date si operatiuni.",
      includes: ["CRM", "Dashboard-uri", "Conturi", "Administrare"],
      sections: [
         { title: "Ce construim", text: "Platforme custom, conturi de utilizator, dashboard-uri si panouri interne." },
         { title: "Cum gandim", text: "Pornim de la fluxurile reale, nu de la template-uri generice." },
         { title: "Rezultat", text: "O platforma care sustine munca zilnica si cresterea businessului." },
      ],
   },
   websites: {
      label: "Site-uri si prezenta digitala",
      tier: "Site-uri si prezenta digitala",
      tagline: "Construim site-uri moderne, rapide si scalabile pentru branduri in crestere.",
      hero: "Prezenta digitala clara, moderna si scalabila.",
      intro: "De la landing pages la marketplace-uri si platforme complexe, livram experiente web premium.",
      includes: ["Landing", "SEO", "Performanta", "Scalare"],
      sections: [
         { title: "Ce livram", text: "Landing pages, site-uri corporate, marketplace-uri si pagini de produs." },
         { title: "Focus", text: "Claritate, viteza, conversie si coerenta vizuala." },
         { title: "Rezultat", text: "Un site care arata premium si lucreaza ca parte din sistemul companiei." },
      ],
   },
   design: {
      label: "UI/UX si design de produs",
      tier: "Design de produs",
      tagline: "Proiectam interfete clare, premium si intuitive pentru produse digitale.",
      hero: "Interfete care transforma complexitatea in claritate.",
      intro: "Designul Zotaris este construit pentru utilizatori reali, procese reale si obiective clare.",
      includes: ["UX", "UI", "Sistem de design", "Prototip"],
      sections: [
         { title: "Ce proiectam", text: "Interfete, fluxuri, prototipuri, design systems si experiente de produs." },
         { title: "Cum lucram", text: "Simplificam deciziile, reducem frictiunea si organizam informatia." },
         { title: "Rezultat", text: "Un produs mai usor de folosit, mai coerent si mai convingator." },
      ],
   },
   courses: {
      label: "Cursuri AI si automatizare",
      tier: "Cursuri AI si automatizare",
      tagline: "Cursuri practice pentru oameni si echipe care vor sa lucreze mai inteligent.",
      hero: "Invata sistemele pe care le construim.",
      intro: "Cursurile sunt bazate pe scenarii reale: taskuri, date, continut, AI si workflow-uri eficiente.",
      includes: ["AI", "Automatizare", "Tool-uri", "Training"],
      sections: [
         { title: "Pentru cine", text: "Persoane, echipe si companii care vor sa foloseasca AI in munca reala." },
         { title: "Ce inveti", text: "Automatizari, prompturi, organizarea datelor si integrarea tool-urilor." },
         { title: "Rezultat", text: "Competente practice, aplicabile imediat in activitatea profesionala." },
      ],
   },
   consulting: {
      label: "Strategie digitala si consultanta",
      tier: "Consultanta digitala",
      tagline: "Analizam procesele si propunem solutii digitale clare, prioritizate si eficiente.",
      hero: "Strategie digitala pentru companii care vor claritate.",
      intro: "Identificam blocaje, oportunitati si conexiuni dintre oameni, procese, date si instrumente.",
      includes: ["Audit", "Plan de actiune", "Procese", "Scalare"],
      sections: [
         { title: "Ce analizam", text: "Procese, departamente, date, tool-uri si obiective de crestere." },
         { title: "Ce livram", text: "O harta clara a solutiilor, prioritatilor si pasilor de implementare." },
         { title: "Rezultat", text: "Decizii digitale mai bune si o directie coerenta pentru dezvoltare." },
      ],
   },
};

const enServices = {
   automation: {
      label: "Automatisierung und AI-Workflows",
      tier: "Automation and AI workflows",
      tagline: "We automate repetitive processes and build intelligent workflows for teams.",
      hero: "AI workflows that remove repetitive work.",
      intro: "We build automation for sales, support, administration, operations, and reporting.",
      includes: ["AI workflows", "Integrations", "CRM", "Reports"],
      sections: [
         { title: "What we connect", text: "Tools, forms, CRMs, email, data, notifications, and reports." },
         { title: "What we optimize", text: "Repetitive tasks, manual processes, and bottlenecks between departments." },
         { title: "Result", text: "A faster, clearer, scalable system with less manual work." },
      ],
   },
   platforms: {
      label: "Individuelle Webplattformen",
      tier: "Custom platforms",
      tagline: "We develop CRMs, dashboards, booking systems, and business applications.",
      hero: "Web platforms built around real company processes.",
      intro: "We create custom systems for internal administration, clients, data, and operations.",
      includes: ["CRM", "Dashboard", "Accounts", "Admin"],
      sections: [
         { title: "What we build", text: "Custom platforms, user accounts, dashboards, and internal panels." },
         { title: "How we think", text: "We start from real workflows, not generic templates." },
         { title: "Result", text: "A platform that supports daily work and business growth." },
      ],
   },
   websites: {
      label: "Websites und digitale Praesenz",
      tier: "Websites and digital presence",
      tagline: "We build modern, fast, scalable websites for growing brands.",
      hero: "A clear, modern, scalable digital presence.",
      intro: "From landing pages to marketplaces and complex platforms, we deliver premium web experiences.",
      includes: ["Landing", "SEO", "Performance", "Scale"],
      sections: [
         { title: "What we deliver", text: "Landing pages, corporate websites, marketplaces, and product pages." },
         { title: "Focus", text: "Clarity, speed, conversion, and visual consistency." },
         { title: "Result", text: "A website that looks premium and works as part of the company system." },
      ],
   },
   design: {
      label: "UI/UX und Produktdesign",
      tier: "Product design",
      tagline: "We design clear, premium, intuitive interfaces for digital products.",
      hero: "Interfaces that turn complexity into clarity.",
      intro: "Zotaris design is built for real users, real processes, and clear objectives.",
      includes: ["UX", "UI", "Design system", "Prototype"],
      sections: [
         { title: "What we design", text: "Interfaces, flows, prototypes, design systems, and product experiences." },
         { title: "How we work", text: "We simplify decisions, reduce friction, and organize information." },
         { title: "Result", text: "A product that is easier to use, more coherent, and more convincing." },
      ],
   },
   courses: {
      label: "AI & Automation Courses",
      tier: "AI and automation courses",
      tagline: "Practical courses for people and teams who want to work smarter.",
      hero: "Learn the systems we build.",
      intro: "Courses are based on real scenarios: tasks, data, content, AI, and efficient workflows.",
      includes: ["AI", "Automation", "Tools", "Training"],
      sections: [
         { title: "For whom", text: "People, teams, and companies that want to use AI in real work." },
         { title: "What you learn", text: "Automation, prompts, data organization, and tool integration." },
         { title: "Result", text: "Practical skills that can be applied immediately." },
      ],
   },
   consulting: {
      label: "Digital Strategy & Consulting",
      tier: "Digital consulting",
      tagline: "We analyze processes and propose clear, prioritized, efficient digital solutions.",
      hero: "Digital strategy for companies that want clarity.",
      intro: "We identify bottlenecks, opportunities, and connections between people, processes, data, and tools.",
      includes: ["Audit", "Roadmap", "Processes", "Scale"],
      sections: [
         { title: "What we analyze", text: "Processes, departments, data, tools, and growth objectives." },
         { title: "What we deliver", text: "A clear map of solutions, priorities, and implementation steps." },
         { title: "Result", text: "Better digital decisions and a coherent direction for development." },
      ],
   },
};

const deServices = {
   automation: {
      label: "Automation & AI Workflows",
      tier: "Automatisierung und AI-Workflows",
      tagline: "Wir automatisieren repetitive Prozesse und bauen intelligente Workflows fuer Teams.",
      hero: "AI-Workflows, die repetitive Arbeit reduzieren.",
      intro: "Wir bauen Automatisierungen fuer Sales, Support, Administration, Operations und Reporting.",
      includes: ["AI Workflows", "Integrationen", "CRM", "Reports"],
      sections: [
         { title: "Was wir verbinden", text: "Tools, Formulare, CRMs, E-Mail, Daten, Benachrichtigungen und Reports." },
         { title: "Was wir optimieren", text: "Repetitive Aufgaben, manuelle Prozesse und Engpaesse zwischen Abteilungen." },
         { title: "Ergebnis", text: "Ein schnelleres, klareres und skalierbares System mit weniger manueller Arbeit." },
      ],
   },
   platforms: {
      label: "Custom Web Platforms",
      tier: "Individuelle Plattformen",
      tagline: "Wir entwickeln CRMs, Dashboards, Buchungssysteme und Business-Anwendungen.",
      hero: "Webplattformen, gebaut um reale Unternehmensprozesse.",
      intro: "Wir erstellen individuelle Systeme fuer interne Verwaltung, Kunden, Daten und Operations.",
      includes: ["CRM", "Dashboard", "Accounts", "Admin"],
      sections: [
         { title: "Was wir bauen", text: "Custom-Plattformen, Nutzerkonten, Dashboards und interne Panels." },
         { title: "Wie wir denken", text: "Wir starten bei echten Workflows, nicht bei generischen Templates." },
         { title: "Ergebnis", text: "Eine Plattform, die taegliche Arbeit und Wachstum unterstuetzt." },
      ],
   },
   websites: {
      label: "Websites & Digital Presence",
      tier: "Websites und digitale Praesenz",
      tagline: "Wir bauen moderne, schnelle und skalierbare Websites fuer wachsende Marken.",
      hero: "Eine klare, moderne und skalierbare digitale Praesenz.",
      intro: "Von Landing Pages bis zu Marketplaces und komplexen Plattformen liefern wir Premium-Web-Erlebnisse.",
      includes: ["Landing", "SEO", "Performance", "Scale"],
      sections: [
         { title: "Was wir liefern", text: "Landing Pages, Corporate Websites, Marketplaces und Produktseiten." },
         { title: "Fokus", text: "Klarheit, Geschwindigkeit, Conversion und visuelle Konsistenz." },
         { title: "Ergebnis", text: "Eine Website, die premium wirkt und Teil des Unternehmenssystems ist." },
      ],
   },
   design: {
      label: "UI/UX & Product Design",
      tier: "Produktdesign",
      tagline: "Wir gestalten klare, hochwertige und intuitive Interfaces fuer digitale Produkte.",
      hero: "Interfaces, die Komplexitaet in Klarheit verwandeln.",
      intro: "Zotaris Design entsteht fuer reale Nutzer, reale Prozesse und klare Ziele.",
      includes: ["UX", "UI", "Designsystem", "Prototyp"],
      sections: [
         { title: "Was wir gestalten", text: "Interfaces, Flows, Prototypen, Designsysteme und Produkterlebnisse." },
         { title: "Wie wir arbeiten", text: "Wir vereinfachen Entscheidungen, reduzieren Reibung und organisieren Information." },
         { title: "Ergebnis", text: "Ein Produkt, das leichter nutzbar, kohärenter und überzeugender ist." },
      ],
   },
   courses: {
      label: "AI- und Automatisierungskurse",
      tier: "AI- und Automatisierungskurse",
      tagline: "Praxisnahe Kurse fuer Menschen und Teams, die smarter arbeiten wollen.",
      hero: "Lerne die Systeme, die wir bauen.",
      intro: "Die Kurse basieren auf realen Szenarien: Aufgaben, Daten, Content, AI und effiziente Workflows.",
      includes: ["AI", "Automation", "Tools", "Training"],
      sections: [
         { title: "Fuer wen", text: "Menschen, Teams und Unternehmen, die AI in echter Arbeit nutzen wollen." },
         { title: "Was du lernst", text: "Automatisierung, Prompts, Datenorganisation und Tool-Integration." },
         { title: "Ergebnis", text: "Praktische Skills, die sofort angewendet werden koennen." },
      ],
   },
   consulting: {
      label: "Digitale Strategie und Beratung",
      tier: "Digitale Beratung",
      tagline: "Wir analysieren Prozesse und schlagen klare, priorisierte digitale Loesungen vor.",
      hero: "Digitale Strategie fuer Unternehmen, die Klarheit wollen.",
      intro: "Wir identifizieren Engpaesse, Chancen und Verbindungen zwischen Menschen, Prozessen, Daten und Tools.",
      includes: ["Audit", "Roadmap", "Prozesse", "Skalierung"],
      sections: [
         { title: "Was wir analysieren", text: "Prozesse, Abteilungen, Daten, Tools und Wachstumsziele." },
         { title: "Was wir liefern", text: "Eine klare Map mit Loesungen, Prioritaeten und Umsetzungsschritten." },
         { title: "Ergebnis", text: "Bessere digitale Entscheidungen und eine klare Entwicklungsrichtung." },
      ],
   },
};

const serviceDetails = {
   RO: {
      automation: {
         story: {
            title: "Automatizare care scoate munca repetitiva din sistem",
            intro: "Automatizarea buna nu inseamna sa legam doua aplicatii si sa speram ca merge. Inseamna sa intelegem procesul, exceptiile si oamenii care il folosesc zilnic.",
            paragraphs: [
               "Incepem prin a urmari unde se pierde timp: mesaje copiate manual, formulare prelucrate de mana, lead-uri care raman fara raspuns, rapoarte facute la final de zi sau taskuri mutate intre tool-uri.",
               "Dupa ce procesul este clar, construim fluxuri care preiau datele, le valideaza, trimit notificari, actualizeaza CRM-ul si pornesc actiuni fara sa ceara interventie la fiecare pas.",
               "Rezultatul este un sistem care lucreaza in fundal. Echipa ramane cu deciziile importante, iar operatiunile repetitive devin rapide, urmaribile si mai greu de uitat.",
            ],
         },
         outcomesTitle: "Ce poate schimba in business",
         outcomesText: "Pentru automatizari masuram impactul prin timp economisit, mai putine erori si viteza mai mare de raspuns.",
         outcomes: [
            ["90%", "mai putina munca repetitiva", "Taskurile care se repeta zilnic pot fi mutate in fluxuri automate."],
            ["24/7", "raspuns si procesare", "Lead-urile, notificarile si datele pot circula chiar si cand echipa nu este online."],
            ["SEO", "continut si date sincronizate", "Automatizarile pot sustine publicarea, raportarea si actualizarea informatiei pentru site."],
         ],
      },
      platforms: {
         story: {
            title: "Platforme construite pe modul real de lucru",
            intro: "O platforma buna nu este doar un panou frumos. Este locul unde echipa vede datele, ia decizii si executa procesele fara sa sara intre multe tool-uri.",
            paragraphs: [
               "Analizam rolurile, datele, aprobarile si actiunile care apar zilnic. Din acestea construim un sistem cu panouri clare, permisiuni, formulare, rapoarte si logica interna.",
               "Platforma poate porni simplu: un CRM, un dashboard, o zona de administrare sau un sistem de programari. Important este sa fie construita modular, ca sa poata creste fara sa fie rescrisa.",
               "La final, businessul primeste un instrument central, adaptat proceselor sale, nu un template fortat peste o realitate mult mai complexa.",
            ],
         },
         outcomesTitle: "Ce devine mai simplu",
         outcomesText: "Platformele custom ajuta mai ales cand datele si actiunile sunt imprastiate in multe locuri.",
         outcomes: [
            ["1", "loc central pentru operare", "Clienti, comenzi, programari, rapoarte si taskuri pot sta intr-un sistem coerent."],
            ["60%", "mai putine salturi intre tool-uri", "Echipa lucreaza mai rapid cand informatia este conectata."],
            ["Scale", "gata pentru crestere", "Arhitectura modulara permite functii noi fara haos in cod sau proces."],
         ],
      },
      websites: {
         story: {
            title: "Site-uri care explica, conving si se misca rapid",
            intro: "Un site nu trebuie sa fie doar o prezentare. Pentru multe businessuri este primul filtru de incredere, prima conversatie si primul pas spre vanzare.",
            paragraphs: [
               "Lucram la structura informatiei, mesaj, sectiuni, viteza si responsive design. Fiecare bloc trebuie sa ajute vizitatorul sa inteleaga repede ce oferi si de ce merita sa continue.",
               "Pe partea tehnica, ne uitam la performanta, accesibilitate, SEO de baza, markup clar si imagini potrivite. Un site frumos care se incarca greu pierde oameni inainte sa citeasca oferta.",
               "Cand este nevoie, conectam site-ul cu formulare, CRM, analytics, booking sau automatizari, ca prezenta digitala sa devina parte din sistemul businessului.",
            ],
         },
         outcomesTitle: "Unde se vede impactul",
         outcomesText: "Pentru website-uri conteaza claritatea, viteza, SEO si conversia.",
         outcomes: [
            ["SEO", "structura mai clara", "Pagini, titluri si continut organizate pentru oameni si motoare de cautare."],
            ["<2s", "incarcare mai rapida", "Optimizam imagini, layout si cod pentru o experienta fluida."],
            ["CVR", "mai multe actiuni", "Formulare, CTA-uri si sectiuni construite pentru conversii reale."],
         ],
      },
      design: {
         story: {
            title: "Design care face produsul mai usor de folosit",
            intro: "Designul nu este decor. Este felul in care utilizatorul intelege ce are de facut, ce este important si unde trebuie sa apese.",
            paragraphs: [
               "Pornim de la continut, obiectiv si scenariile reale de utilizare. Apoi organizam informatia in ecrane, fluxuri si componente care pot fi folosite repetat.",
               "Pentru produse si platforme, designul trebuie sa reduca frictiunea: mai putine decizii inutile, mai putine campuri confuze, mai multa claritate in actiuni.",
               "Rezultatul poate fi un landing page, o interfata de dashboard, un prototip sau un design system care pastreaza coerenta cand produsul creste.",
            ],
         },
         outcomesTitle: "Ce imbunatateste designul",
         outcomesText: "Un design bun reduce confuzia si face produsul mai usor de vandut, folosit si extins.",
         outcomes: [
            ["UX", "fluxuri mai clare", "Utilizatorii inteleg mai repede ce pot face si unde trebuie sa mearga."],
            ["UI", "interfata coerenta", "Componente, ritm vizual si ierarhie potrivite pentru produs."],
            ["Brand", "mai multa incredere", "Un produs coerent vizual pare mai serios si mai usor de ales."],
         ],
      },
      courses: {
         story: {
            title: "Training practic pentru echipe care vor sa aplice AI",
            intro: "Cursurile au sens doar daca oamenii pot folosi ce invata in munca reala. De aceea lucram pe exemple, procese si tool-uri apropiate de activitatea lor.",
            paragraphs: [
               "Incepem cu nivelul echipei si cu tipurile de taskuri pe care vrea sa le imbunatateasca: continut, analiza, suport, vanzari, raportare sau automatizare.",
               "Construim exercitii practice: prompturi, fluxuri simple, organizarea datelor, generarea de materiale si conectarea tool-urilor.",
               "Scopul nu este sa prezentam AI ca magie, ci sa dam echipei metode clare prin care economiseste timp si ia decizii mai bine.",
            ],
         },
         outcomesTitle: "Ce ramane dupa training",
         outcomesText: "Cursurile trebuie sa lase competente aplicabile, nu doar inspiratie de moment.",
         outcomes: [
            ["AI", "utilizare mai sigura", "Echipa intelege ce poate cere, cum verifica si cum aplica rezultatele."],
            ["30%", "timp economisit pe taskuri", "Procesele de continut, analiza si raportare pot deveni mai rapide."],
            ["Playbook", "metode repetabile", "Participantii pleaca cu exemple si fluxuri pe care le pot refolosi."],
         ],
      },
      consulting: {
         story: {
            title: "Consultanta pentru decizii digitale mai clare",
            intro: "Uneori problema nu este lipsa unui tool, ci lipsa unei harti. Consultingul ajuta sa vedem ce merita construit, automatizat sau schimbat prima data.",
            paragraphs: [
               "Analizam procesele, departamentele, datele si sistemele existente. Cautam blocaje, duplicari, costuri ascunse si zone unde digitalizarea ar produce impact real.",
               "Apoi transformam observatiile intr-o directie: ce se face acum, ce se amana, ce se automatizeaza si ce trebuie construit custom.",
               "Rezultatul este o foaie de parcurs clara, cu prioritati si pasi, astfel incat investitia digitala sa fie mai calculata si mai usor de justificat.",
            ],
         },
         outcomesTitle: "Ce clarificam",
         outcomesText: "Consultanta reduce riscul de a construi lucruri gresite sau prea devreme.",
         outcomes: [
            ["Roadmap", "prioritati clare", "Stii ce merita facut prima data si de ce."],
            ["ROI", "decizii mai calculate", "Legam solutiile digitale de timp, costuri si crestere."],
            ["Audit", "blocaje vizibile", "Procesele devin mai usor de discutat, masurat si imbunatatit."],
         ],
      },
   },
};

serviceDetails.EN = {
   automation: {
      story: {
         title: "Automation that removes repetitive work from the system",
         intro: "Good automation is not just connecting two apps. It means understanding the process, the exceptions, and the people who use it every day.",
         paragraphs: [
            "We start by finding where time is lost: copied messages, manually processed forms, unanswered leads, end-of-day reports, or tasks moved between tools.",
            "Once the process is clear, we build workflows that receive data, validate it, send notifications, update the CRM, and trigger actions without manual input at every step.",
            "The result is a system that works in the background. The team keeps the important decisions, while repetitive operations become faster, trackable, and harder to forget.",
         ],
      },
      outcomesTitle: "What it can change",
      outcomesText: "For automation, impact is measured in saved time, fewer errors, and faster response.",
      outcomes: [
         ["90%", "less repetitive work", "Daily repeated tasks can move into automated workflows."],
         ["24/7", "response and processing", "Leads, notifications, and data can move even when the team is offline."],
         ["SEO", "content and data sync", "Automation can support publishing, reporting, and website information updates."],
      ],
   },
   platforms: {
      story: {
         title: "Platforms built around real work",
         intro: "A good platform is not just a nice dashboard. It is where the team sees data, makes decisions, and runs processes without jumping between tools.",
         paragraphs: [
            "We analyze roles, data, approvals, and daily actions. From that, we build a system with clear panels, permissions, forms, reports, and internal logic.",
            "The platform can start simple: CRM, dashboard, admin area, or booking system. What matters is building it modularly, so it can grow without a rewrite.",
            "In the end, the business gets a central tool adapted to its process, not a generic template forced over a complex reality.",
         ],
      },
      outcomesTitle: "What becomes easier",
      outcomesText: "Custom platforms help most when data and actions are scattered across many places.",
      outcomes: [
         ["1", "central operating place", "Clients, orders, bookings, reports, and tasks can live in one coherent system."],
         ["60%", "fewer tool jumps", "The team works faster when information is connected."],
         ["Scale", "ready for growth", "A modular architecture allows new features without chaos in code or process."],
      ],
   },
   websites: {
      story: {
         title: "Websites that explain, convince, and load fast",
         intro: "A website should not be only a presentation. For many businesses it is the first trust filter, the first conversation, and the first step toward a sale.",
         paragraphs: [
            "We work on information structure, message, sections, speed, and responsive design. Every block should help visitors quickly understand what you offer and why they should continue.",
            "Technically, we focus on performance, accessibility, basic SEO, clear markup, and proper images. A beautiful website that loads slowly loses people before they read the offer.",
            "When needed, we connect the website with forms, CRM, analytics, booking, or automation, so the digital presence becomes part of the business system.",
         ],
      },
      outcomesTitle: "Where the impact appears",
      outcomesText: "For websites, clarity, speed, SEO, and conversion matter most.",
      outcomes: [
         ["SEO", "clearer structure", "Pages, headings, and content organized for people and search engines."],
         ["<2s", "faster loading", "We optimize images, layout, and code for a smoother experience."],
         ["CVR", "more actions", "Forms, CTAs, and sections built for real conversions."],
      ],
   },
   design: {
      story: {
         title: "Design that makes the product easier to use",
         intro: "Design is not decoration. It is how users understand what to do, what matters, and where to click.",
         paragraphs: [
            "We start from content, goals, and real usage scenarios. Then we organize information into screens, flows, and reusable components.",
            "For products and platforms, design must reduce friction: fewer unnecessary decisions, fewer confusing fields, and clearer actions.",
            "The result can be a landing page, dashboard interface, prototype, or design system that keeps consistency as the product grows.",
         ],
      },
      outcomesTitle: "What design improves",
      outcomesText: "Good design reduces confusion and makes the product easier to sell, use, and extend.",
      outcomes: [
         ["UX", "clearer flows", "Users understand faster what they can do and where to go."],
         ["UI", "coherent interface", "Components, visual rhythm, and hierarchy built for the product."],
         ["Brand", "more trust", "A visually coherent product feels more serious and easier to choose."],
      ],
   },
   courses: {
      story: {
         title: "Practical training for teams that want to apply AI",
         intro: "Courses matter only when people can use what they learn in real work. That is why we work with examples, processes, and tools close to their daily activity.",
         paragraphs: [
            "We start with the team level and the tasks they want to improve: content, analysis, support, sales, reporting, or automation.",
            "We build practical exercises: prompts, simple workflows, data organization, material generation, and tool connections.",
            "The goal is not to present AI as magic, but to give the team clear methods for saving time and making better decisions.",
         ],
      },
      outcomesTitle: "What remains after training",
      outcomesText: "Courses should leave applicable skills, not only temporary inspiration.",
      outcomes: [
         ["AI", "safer usage", "The team understands what to ask, how to verify, and how to apply results."],
         ["30%", "time saved on tasks", "Content, analysis, and reporting processes can become faster."],
         ["Playbook", "repeatable methods", "Participants leave with examples and workflows they can reuse."],
      ],
   },
   consulting: {
      story: {
         title: "Consulting for clearer digital decisions",
         intro: "Sometimes the problem is not the lack of a tool, but the lack of a map. Consulting helps reveal what should be built, automated, or changed first.",
         paragraphs: [
            "We analyze processes, departments, data, and existing systems. We look for bottlenecks, duplication, hidden costs, and areas where digitalization can create real impact.",
            "Then we turn observations into direction: what to do now, what to delay, what to automate, and what should be custom built.",
            "The result is a clear roadmap with priorities and steps, so the digital investment becomes more calculated and easier to justify.",
         ],
      },
      outcomesTitle: "What we clarify",
      outcomesText: "Consulting reduces the risk of building the wrong things or building too early.",
      outcomes: [
         ["Roadmap", "clear priorities", "You know what should be done first and why."],
         ["ROI", "better decisions", "We connect digital solutions with time, cost, and growth."],
         ["Audit", "visible bottlenecks", "Processes become easier to discuss, measure, and improve."],
      ],
   },
};

serviceDetails.DE = {
   automation: {
      story: {
         title: "Automatisierung, die repetitive Arbeit aus dem System nimmt",
         intro: "Gute Automatisierung bedeutet nicht nur zwei Apps zu verbinden. Sie beginnt mit Prozess, Ausnahmen und den Menschen, die damit taeglich arbeiten.",
         paragraphs: [
            "Wir suchen zuerst, wo Zeit verloren geht: kopierte Nachrichten, manuell bearbeitete Formulare, unbeantwortete Leads, Tagesberichte oder Aufgaben, die zwischen Tools verschoben werden.",
            "Wenn der Prozess klar ist, bauen wir Workflows, die Daten aufnehmen, pruefen, Benachrichtigungen senden, CRM aktualisieren und Aktionen starten, ohne jeden Schritt manuell auszufuehren.",
            "Das Ergebnis ist ein System, das im Hintergrund arbeitet. Das Team behaelt die wichtigen Entscheidungen, waehrend repetitive Ablaufe schneller und nachvollziehbarer werden.",
         ],
      },
      outcomesTitle: "Was sich im Business veraendern kann",
      outcomesText: "Bei Automatisierung messen wir Wirkung ueber gesparte Zeit, weniger Fehler und schnellere Reaktion.",
      outcomes: [
         ["90%", "weniger repetitive Arbeit", "Taeglich wiederholte Aufgaben koennen in automatische Workflows verschoben werden."],
         ["24/7", "Antwort und Verarbeitung", "Leads, Benachrichtigungen und Daten koennen auch ausserhalb der Arbeitszeit laufen."],
         ["SEO", "Content und Daten synchron", "Automatisierung kann Veroeffentlichung, Reporting und Website-Updates unterstuetzen."],
      ],
   },
   platforms: {
      story: {
         title: "Plattformen, gebaut um echte Arbeit",
         intro: "Eine gute Plattform ist nicht nur ein schoenes Dashboard. Sie ist der Ort, an dem das Team Daten sieht, Entscheidungen trifft und Prozesse ohne Tool-Wechsel ausfuehrt.",
         paragraphs: [
            "Wir analysieren Rollen, Daten, Freigaben und taegliche Aktionen. Daraus entsteht ein System mit klaren Panels, Rechten, Formularen, Reports und interner Logik.",
            "Die Plattform kann einfach starten: CRM, Dashboard, Adminbereich oder Buchungssystem. Wichtig ist ein modularer Aufbau, damit sie wachsen kann.",
            "Am Ende bekommt das Business ein zentrales Tool fuer seine Prozesse, nicht ein generisches Template fuer eine komplexe Realitaet.",
         ],
      },
      outcomesTitle: "Was einfacher wird",
      outcomesText: "Custom-Plattformen helfen besonders, wenn Daten und Aktionen an vielen Orten verstreut sind.",
      outcomes: [
         ["1", "zentraler Ort fuer Betrieb", "Kunden, Auftraege, Buchungen, Reports und Aufgaben koennen in einem System leben."],
         ["60%", "weniger Tool-Wechsel", "Das Team arbeitet schneller, wenn Informationen verbunden sind."],
         ["Scale", "bereit fuer Wachstum", "Modulare Architektur erlaubt neue Funktionen ohne Chaos in Code oder Prozess."],
      ],
   },
   websites: {
      story: {
         title: "Websites, die erklaeren, ueberzeugen und schnell laden",
         intro: "Eine Website ist nicht nur Praesentation. Fuer viele Unternehmen ist sie der erste Vertrauensfilter, das erste Gespraech und der erste Schritt zum Verkauf.",
         paragraphs: [
            "Wir arbeiten an Informationsstruktur, Botschaft, Sektionen, Geschwindigkeit und Responsive Design. Jeder Block soll schnell zeigen, was du anbietest und warum es relevant ist.",
            "Technisch achten wir auf Performance, Accessibility, Basis-SEO, klares Markup und passende Bilder. Eine schoene, aber langsame Website verliert Menschen vor dem Angebot.",
            "Wenn noetig verbinden wir die Website mit Formularen, CRM, Analytics, Booking oder Automatisierung, damit die digitale Praesenz Teil des Business-Systems wird.",
         ],
      },
      outcomesTitle: "Wo der Effekt sichtbar wird",
      outcomesText: "Bei Websites zaehlen Klarheit, Geschwindigkeit, SEO und Conversion.",
      outcomes: [
         ["SEO", "klarere Struktur", "Seiten, Headlines und Inhalte fuer Menschen und Suchmaschinen organisiert."],
         ["<2s", "schnelleres Laden", "Wir optimieren Bilder, Layout und Code fuer eine fluessige Erfahrung."],
         ["CVR", "mehr Aktionen", "Formulare, CTAs und Sektionen fuer echte Conversion gebaut."],
      ],
   },
   design: {
      story: {
         title: "Design, das Produkte leichter nutzbar macht",
         intro: "Design ist keine Dekoration. Es zeigt Nutzern, was zu tun ist, was wichtig ist und wo sie klicken sollen.",
         paragraphs: [
            "Wir starten mit Inhalt, Ziel und realen Nutzungsszenarien. Danach organisieren wir Information in Screens, Flows und wiederverwendbare Komponenten.",
            "Bei Produkten und Plattformen muss Design Reibung reduzieren: weniger unnoetige Entscheidungen, weniger verwirrende Felder und klarere Aktionen.",
            "Das Ergebnis kann eine Landingpage, ein Dashboard-Interface, ein Prototyp oder ein Designsystem sein, das mit dem Produkt mitwaechst.",
         ],
      },
      outcomesTitle: "Was Design verbessert",
      outcomesText: "Gutes Design reduziert Verwirrung und macht ein Produkt leichter zu verkaufen, zu nutzen und zu erweitern.",
      outcomes: [
         ["UX", "klarere Flows", "Nutzer verstehen schneller, was sie tun koennen und wohin sie gehen sollen."],
         ["UI", "konsistentes Interface", "Komponenten, visueller Rhythmus und Hierarchie passend zum Produkt."],
         ["Brand", "mehr Vertrauen", "Ein visuell konsistentes Produkt wirkt serioeser und leichter waehlbar."],
      ],
   },
   courses: {
      story: {
         title: "Praxis-Training fuer Teams, die AI anwenden wollen",
         intro: "Kurse sind nur sinnvoll, wenn Menschen das Gelernte in echter Arbeit nutzen koennen. Deshalb arbeiten wir mit Beispielen, Prozessen und Tools aus ihrem Alltag.",
         paragraphs: [
            "Wir starten mit dem Niveau des Teams und den Aufgaben, die verbessert werden sollen: Content, Analyse, Support, Sales, Reporting oder Automatisierung.",
            "Wir bauen praktische Uebungen: Prompts, einfache Workflows, Datenorganisation, Materialerstellung und Tool-Verbindungen.",
            "Ziel ist nicht AI als Magie zu zeigen, sondern klare Methoden zu geben, mit denen Teams Zeit sparen und bessere Entscheidungen treffen.",
         ],
      },
      outcomesTitle: "Was nach dem Training bleibt",
      outcomesText: "Kurse sollen anwendbare Faehigkeiten hinterlassen, nicht nur kurzfristige Inspiration.",
      outcomes: [
         ["AI", "sicherere Nutzung", "Das Team versteht, was es fragen kann, wie es prueft und wie Ergebnisse angewendet werden."],
         ["30%", "Zeitersparnis bei Aufgaben", "Content-, Analyse- und Reporting-Prozesse koennen schneller werden."],
         ["Playbook", "wiederholbare Methoden", "Teilnehmer gehen mit Beispielen und Workflows, die sie wiederverwenden koennen."],
      ],
   },
   consulting: {
      story: {
         title: "Consulting fuer klarere digitale Entscheidungen",
         intro: "Manchmal fehlt nicht ein Tool, sondern eine Karte. Consulting zeigt, was zuerst gebaut, automatisiert oder veraendert werden sollte.",
         paragraphs: [
            "Wir analysieren Prozesse, Abteilungen, Daten und bestehende Systeme. Wir suchen Engpaesse, Doppelarbeit, versteckte Kosten und Bereiche mit echtem Digitalisierungseffekt.",
            "Danach verwandeln wir Beobachtungen in Richtung: was jetzt passiert, was warten kann, was automatisiert wird und was custom gebaut werden sollte.",
            "Das Ergebnis ist eine klare Roadmap mit Prioritaeten und Schritten, damit digitale Investitionen berechenbarer und leichter begruendbar werden.",
         ],
      },
      outcomesTitle: "Was wir klaeren",
      outcomesText: "Consulting reduziert das Risiko, falsche Dinge oder zu frueh zu bauen.",
      outcomes: [
         ["Roadmap", "klare Prioritaeten", "Du weisst, was zuerst gemacht werden sollte und warum."],
         ["ROI", "bessere Entscheidungen", "Wir verbinden digitale Loesungen mit Zeit, Kosten und Wachstum."],
         ["Audit", "sichtbare Engpaesse", "Prozesse werden leichter zu diskutieren, zu messen und zu verbessern."],
      ],
   },
};

const withServiceDetails = (services, lang) =>
   Object.fromEntries(
      Object.entries(services).map(([id, service]) => [
         id,
         {
            ...service,
            detail: serviceDetails[lang]?.[id] || serviceDetails.RO[id],
         },
      ]),
   );

const roHome = {
   about: {
      title: "Sisteme digitale clare pentru businessuri.",
      text: "Web, automatizari, AI si design de sistem intr-un flux conectat.",
      note: "Nu livram doar pagini web. Construim ecosisteme digitale care sustin cresterea businessului.",
   },
   aboutLegacy: {
      title: "Cine suntem",
      text: "O echipa mica si agila, specializata in produse web rapide, curate si usor de folosit. Cream design-uri la cheie si le implementam in React sau WordPress, cu focus pe performanta si SEO.",
      imageAlt: "Despre Zotaris",
   },
   stats: {
      items: [
         ["35+", "proiecte realizate", "Site-uri, platforme, automatizari si prezentari digitale livrate."],
         ["120+", "procese automatizate", "Taskuri repetitive transformate in fluxuri clare si rapide."],
         ["30+", "clienti satisfacuti", "Businessuri locale si echipe in crestere sustinute digital."],
         ["6+", "sisteme conectate", "CRM, web, AI, date, rapoarte si comunicare intr-un flux coerent."],
      ],
   },
   concept: {
      title: "Miceliul digital care conecteaza businessul tau",
      text: "La fel cum miceliul conecteaza ecosisteme in natura, Zotaris conecteaza procesele, datele si instrumentele unei companii intr-un sistem coerent.",
      nodes: ["Oameni", "Taskuri", "Date", "Clienti", "Rapoarte", "Sisteme"],
   },
   myceliumPreview: {
      eyebrow: "Retea digitala de miceliu v1.02",
      titlePrefix: "De la munca deconectata la un ",
      titleStrong: "sistem digital viu",
      titleSuffix: ".",
      text: "Apasa pe butoane ca sa vezi conceptul: in modul haos, procesele sunt puncte separate. In modul Zotaris, nodurile se strang intr-o retea conectata, iar click-ul trimite un puls prin sistem.",
      stateLabel: "Stare retea",
      chaos: "Haos brut",
      system: "Sistem conectat",
      convert: "Transforma in sistem",
      pulse: "Trimite puls",
      core: "Nucleu inteligent",
      online: "Online",
      fragmented: "Fragmentat",
      routing: "Rata de rutare miceliu",
      activePath: "Pathfinding optim activ",
      disconnectedPoints: "Puncte manuale deconectate",
      latency: "Latenta operatiuni",
      synchronized: "Trigger-e sincronizate imediat",
      waiting: "Asteptare pe transferuri manuale",
      quote: "Workflow-urile digitale nu ar trebui sa fie linii verticale. Sunt retele vii care ruteaza munca inteligent.",
   },
   process: {
      title: "Cum lucram",
      text: "Un sistem conectat, de la descoperire pana la crestere.",
      groups: { inputs: "Intrari", outputs: "Iesiri", result: "Rezultat" },
      nodes: {
         discover: { label: "Trigger", title: "Discover", assistant: "Business Analyst AI", description: "Intelegem cum functioneaza businessul, ce tool-uri sunt folosite, unde echipa pierde timp si ce procese creeaza frictiune.", inputs: ["Context", "Obiective", "Tool-uri", "Echipa"], outputs: ["Vedere business", "Blocaje", "Oportunitati de automatizare"], result: "O intelegere clara a lucrurilor care trebuie imbunatatite primele." },
         audit: { label: "Audit", title: "Map", assistant: "Process Mapper AI", description: "Transformam taskurile imprastiate intr-o harta structurata de actiuni, tool-uri, utilizatori, decizii si date.", inputs: ["Semnale", "Blocaje", "Riscuri"], outputs: ["Harta workflow", "Lista de prioritati", "Logica sistemului"], result: "Procesul businessului devine vizibil si mai usor de reconstruit." },
         core: { label: "Core", title: "AI Core", assistant: "Zotaris AI Core", description: "Este centrul inteligent al sistemului. Conecteaza logica businessului, regulile de automatizare, sursele de date si asistentii AI intr-o infrastructura functionala.", inputs: ["Reguli business", "Date", "Tool-uri", "Actiuni utilizator"], outputs: ["Sistem conectat", "Decizii automate", "Workflow-uri inteligente"], result: "Totul incepe sa lucreze ca un sistem digital conectat." },
         build: { label: "Logica", title: "Build", assistant: "Automation Builder AI", description: "Construim logica de automatizare, integrarile, dashboard-urile, site-urile, tool-urile interne si workflow-urile cu AI.", inputs: ["Roadmap", "Fluxuri", "Prioritati"], outputs: ["Automatizari", "Interfete", "Integrari"], result: "Munca manuala se reduce si taskurile repetitive devin automate." },
         optimize: { label: "Build", title: "Optimize", assistant: "Optimization AI", description: "Testam comportamentul sistemului, eliminam frictiunea, imbunatatim viteza, simplificam actiunile si facem workflow-ul mai stabil.", inputs: ["Sistem", "Interfete", "Automatizari"], outputs: ["Performanta mai buna", "UX mai clar", "Mai putine erori"], result: "Sistemul devine mai rapid, mai clar si mai usor de folosit." },
         grow: { label: "Merge", title: "Grow", assistant: "Growth AI", description: "Sistemul final este pregatit sa sustina mai multi clienti, mai multe date, mai multi membri in echipa si mai multe operatiuni automate.", inputs: ["Scalare", "Metrici", "Iteratii"], outputs: ["Rapoarte", "Workflow-uri scalabile", "Infrastructura de crestere"], result: "Businessul poate creste fara lucru manual inutil." },
      },
      steps: [
         ["Discover", "Analizam businessul, procesele, blocajele si obiectivele."],
         ["Map", "Cream o harta clara a fluxurilor care trebuie conectate sau automatizate."],
         ["Build", "Dezvoltam sistemele, automatizarile, interfetele si integrarile necesare."],
         ["Optimize", "Testam, rafinam si imbunatatim sistemul pentru performanta."],
         ["Grow", "Lasam businessul cu o infrastructura digitala care poate creste natural."],
      ],
   },
   why: {
      title: "De ce Zotaris",
      text: "Zotaris nu adauga doar un instrument nou. Zotaris creeaza conexiunile dintre instrumente, oameni si procese.",
      metrics: [
         ["Vedere de sistem", "Mapam businessul tau ca un sistem conectat."],
         ["Construit pentru scalare", "Construim sisteme clare care pot creste impreuna cu tine."],
         ["Executie conectata", "Conectam web, AI, automatizari si fluxuri reale de lucru."],
      ],
      points: [
         "vedem businessul ca un ecosistem",
         "conectam web development, AI, automatizari si design",
         "construim solutii personalizate",
         "optimizam munca reala",
         "gandim pe termen lung: scalabilitate, mentenanta, claritate",
      ],
   },
   team: {
      title: "Echipa care construieste retele digitale inteligente",
      text: "In spatele fiecarui sistem Zotaris este o echipa care combina gandirea tehnica, designul, strategia si intelegerea proceselor reale de business.",
      people: [
         ["Cristian Petic", "Fondator, mentor, CEO si coordonator de vanzari pentru cursuri si discutii cu clientii.", ["Fondator", "CEO", "Mentor", "Course Sales", "Client Meetings"]],
         ["Daniel Diacon", "COO, lead developer, UI/UX designer si graphic designer.", ["COO", "Lead Developer", "UI/UX Designer", "Graphic Designer"]],
         ["Veronica Luca", "Web developer, web designer si manager.", ["Web Developer", "Web Designer", "Manager"]],
         ["Luchian Nicolae", "Manager freelance, coordonator de colaboratori si automatizari cu AI.", ["Freelance Manager", "Coordonator", "AI Automation"]],
         ["Sebastian Rusu", "Specialist AI automation, sales si coordonare pentru colaborari externe.", ["AI Automation", "Sales", "External Collaboration"]],
      ],
   },
   who: {
      title: "O echipa concentrata pe crestere digitala.",
      text: "Combinam designul, dezvoltarea, automatizarea si strategia pentru a construi fluxuri digitale clare pentru businessuri in crestere.",
      cta: "Vezi echipa",
      imageAlt: "Echipa Zotaris",
   },
   courses: {
      title: "Cursuri practice de AI si automatizare",
      text: "Cursurile Zotaris sunt construite in jurul scenariilor reale: automatizarea taskurilor, organizarea datelor, generarea de continut si integrarea AI in procese.",
      items: [
         ["AI pentru business", "AI pentru vanzari, suport, continut, analiza si productivitate."],
         ["Bazele automatizarii", "Automatizezi taskuri repetitive fara sa pierzi controlul procesului."],
         ["Workflow-uri cu tool-uri moderne", "Construiesti sisteme rapide conectate la procese reale."],
         ["Training personalizat pentru echipe", "Training adaptat pentru compania si procesele tale."],
      ],
   },
   faq: {
      title: "Intrebari frecvente",
      items: [
         ["Ce face exact Zotaris?", "Zotaris construieste site-uri, platforme web, automatizari, AI workflows si sisteme care conecteaza procese interne. Incepem de la problema reala: unde se pierde timp, ce se repeta si ce informatii trebuie sa circule mai clar intre oameni, tool-uri si clienti."],
         ["Lucrati doar cu companii mari?", "Nu. Lucram cu startup-uri, businessuri locale, companii in crestere si echipe care vor sa automatizeze munca. Important este sa existe un proces real de imbunatatit: vanzari, suport, programari, administrare, date sau comunicare."],
         ["Faceti doar site-uri?", "Nu. Site-urile sunt doar o parte. Putem construi si platforme, dashboard-uri, sisteme interne, CRM-uri usoare, formulare conectate, integrari si automatizari care continua munca dupa ce utilizatorul trimite o cerere."],
         ["Ce inseamna automatizare pentru business?", "Automatizarea inseamna reducerea muncii repetitive: taskuri, mesaje, formulare, rapoarte, programari, notificari, CRM si date. Scopul nu este sa inlocuim echipa, ci sa o scapam de operatiuni manuale si sa facem procesul mai rapid, clar si verificabil."],
         ["Pot cere o solutie complet personalizata?", "Da. Construim solutii custom in functie de procesele reale ale fiecarui business. Analizam fluxul, alegem ce trebuie automatizat sau construit si livram o solutie care poate creste treptat, nu doar un element izolat."],
      ],
   },
};

const enHome = {
   about: {
     
       title: "Clear digital systems for business.",
      text: "Web, automation, AI, and system design in one connected flow.",
      note: "We do not deliver just web pages. We build digital ecosystems that support business growth.",
   },
   aboutLegacy: {
      title: "Who we are",
      text: "A small, agile team specialized in fast, clean, easy-to-use web products. We create complete designs and implement them in React or WordPress, with a focus on performance and SEO.",
      imageAlt: "About Zotaris",
   },
   stats: {
      items: [
         ["35+", "completed projects", "Websites, platforms, automation, and digital presentations delivered."],
         ["120+", "automated processes", "Repetitive tasks turned into clear and fast workflows."],
         ["30+", "satisfied clients", "Local businesses and growing teams supported digitally."],
         ["6+", "connected systems", "CRM, web, AI, data, reports, and communication in one coherent flow."],
      ],
   },
   concept: {
      title: "Digital mycelium for modern business",
      text: "Like mycelium connects ecosystems in nature, Zotaris connects processes, data, and tools into one coherent digital system.",
      nodes: ["People", "Tasks", "Data", "Clients", "Reports", "Systems"],
   },
   myceliumPreview: {
      eyebrow: "Digital Mycelium Network v1.02",
      titlePrefix: "From disconnected work to a ",
      titleStrong: "living digital system",
      titleSuffix: ".",
      text: "Press the buttons to see the concept: in chaos mode, processes are separate points. In Zotaris mode, nodes gather into a connected network, and a click sends a pulse through the system.",
      stateLabel: "Network state",
      chaos: "Raw chaos",
      system: "Connected system",
      convert: "Convert to system",
      pulse: "Send signal pulse",
      core: "Intelligence Core",
      online: "Online",
      fragmented: "Fragmented",
      routing: "Mycelium Routing Ratio",
      activePath: "Active optimal pathfinding",
      disconnectedPoints: "Disconnected manual points",
      latency: "Operations latency",
      synchronized: "Immediate synchronized triggers",
      waiting: "Waiting on manual transfers",
      quote: "Digital workflows should not be vertical lines. They are live networks that route work intelligently.",
   },
   process: {
      title: "How we work",
      text: "One connected system, from discovery to growth.",
      groups: { inputs: "Inputs", outputs: "Outputs", result: "Result" },
      nodes: {
         discover: { label: "Trigger", title: "Discover", assistant: "Business Analyst AI", description: "We understand how the business works, what tools are used, where the team loses time, and which processes create friction.", inputs: ["Context", "Goals", "Tools", "Team"], outputs: ["Business overview", "Pain points", "Automation opportunities"], result: "A clear understanding of what should be improved first." },
         audit: { label: "Audit", title: "Map", assistant: "Process Mapper AI", description: "We transform scattered tasks into a structured map of actions, tools, users, decisions, and data movement.", inputs: ["Signals", "Bottlenecks", "Risks"], outputs: ["Workflow map", "Priority list", "System logic"], result: "The business process becomes visible and easier to rebuild." },
         core: { label: "Core", title: "AI Core", assistant: "Zotaris AI Core", description: "This is the intelligent center of the system. It connects business logic, automation rules, data sources, and AI assistants into one working infrastructure.", inputs: ["Business rules", "Data", "Tools", "User actions"], outputs: ["Connected system", "Automated decisions", "Smart workflows"], result: "Everything starts working as one connected digital system." },
         build: { label: "Logic", title: "Build", assistant: "Automation Builder AI", description: "We build the actual automation logic, integrations, dashboards, websites, internal tools, and AI-powered workflows.", inputs: ["Roadmap", "Flows", "Priorities"], outputs: ["Automations", "Interfaces", "Integrations"], result: "Manual work is reduced and repetitive tasks become automatic." },
         optimize: { label: "Build", title: "Optimize", assistant: "Optimization AI", description: "We test how the system behaves, remove friction, improve speed, simplify actions, and make the workflow more reliable.", inputs: ["System", "Interfaces", "Automations"], outputs: ["Better performance", "Cleaner UX", "Fewer errors"], result: "The system becomes faster, clearer, and easier to use." },
         grow: { label: "Merge", title: "Grow", assistant: "Growth AI", description: "The final system is ready to support more clients, more data, more team members, and more automated operations over time.", inputs: ["Scale", "Metrics", "Iterations"], outputs: ["Reports", "Scalable workflows", "Growth infrastructure"], result: "The business can grow without adding unnecessary manual work." },
      },
      steps: [
         ["Discover", "We analyze the business, processes, bottlenecks, and goals."],
         ["Map", "We create a clear map of flows that must be connected or automated."],
         ["Build", "We develop systems, automations, interfaces, and integrations."],
         ["Optimize", "We test, refine, and improve the system for performance."],
         ["Grow", "We leave the business with digital infrastructure that can grow naturally."],
      ],
   },
   why: {
      title: "Why Zotaris ",
      text: "Zotaris does not add just another tool. We create the connections between tools, people, and processes.",
      metrics: [
         ["System view", "We map your business as one connected system."],
         ["Built for scale", "We build clean systems that can grow with you."],
         ["Connected execution", "We connect web, AI, automation, and real workflows."],
      ],
      points: [
         "we see business as an ecosystem",
         "we connect web development, AI, automation, and design",
         "we build custom solutions",
         "we optimize real work",
         "we think long-term: scalability, maintenance, clarity",
      ],
   },
   team: {
      title: "The people behind intelligent digital networks",
      text: "Behind every Zotaris system is a team that combines technical thinking, design, strategy, and understanding of real business processes.",
      people: [
         ["Cristian Petic", "Founder, mentor, CEO, and sales coordinator for courses and client meetings.", ["Founder", "CEO", "Mentor", "Course Sales", "Client Meetings"]],
         ["Daniel Diacon", "COO, lead developer, UI/UX designer, and graphic designer.", ["COO", "Lead Developer", "UI/UX Designer", "Graphic Designer"]],
         ["Veronica Luca", "Web developer, web designer, and manager.", ["Web Developer", "Web Designer", "Manager"]],
         ["Luchian Nicolae", "Freelance manager, collaborator coordinator, and AI automation coordinator.", ["Freelance Manager", "Coordinator", "AI Automation"]],
         ["Sebastian Rusu", "AI automation specialist, sales, and external collaboration coordination.", ["AI Automation", "Sales", "External Collaboration"]],
      ],
   },
   who: {
      title: "A focused team for digital growth.",
      text: "We combine design, development, automation, and strategy to build clear digital workflows for growing businesses.",
      cta: "Our team",
      imageAlt: "Zotaris team",
   },
   courses: {
      title: "Practical AI and automation courses",
      text: "Zotaris courses are built around real scenarios: task automation, data organization, content generation, and AI integration into processes.",
      items: [
         ["AI for Business", "AI for sales, support, content, analysis, and productivity."],
         ["Automation Basics", "Automate repetitive tasks without losing process control."],
         ["Modern tool workflows", "Build fast systems with tools connected to real processes."],
         ["Custom Training for Teams", "Training adapted to your company and processes."],
      ],
   },
   faq: {
      title: "FAQ",
      items: [
         ["What exactly does Zotaris do?", "Zotaris builds websites, web platforms, automation, AI workflows, and systems that connect internal processes. We start from the real problem: where time is lost, what repeats, and what information needs to move more clearly between people, tools, and clients."],
         ["Do you work only with large companies?", "No. We work with startups, local businesses, growing companies, and teams that want to automate work. What matters is having a real process to improve: sales, support, bookings, administration, data, or communication."],
         ["Do you only make websites?", "No. Websites are only one part. We can also build platforms, dashboards, internal systems, lightweight CRMs, connected forms, integrations, and automations that continue the work after a user sends a request."],
         ["What does business automation mean?", "Automation means reducing repetitive work: tasks, messages, forms, reports, bookings, notifications, CRM, and data. The goal is not to replace the team, but to remove manual operations and make the process faster, clearer, and easier to track."],
         ["Can I request a fully custom solution?", "Yes. We build custom solutions based on real business processes. We analyze the flow, decide what should be automated or built, and deliver a solution that can grow over time, not just an isolated element."],
      ],
   },
};

const deHome = {
   about: {
      title: "Klare digitale Systeme fuer Unternehmen.",
      text: "Web, Automatisierung, AI und Systemdesign in einem verbundenen Flow.",
      note: "Wir liefern nicht nur Webseiten. Wir bauen digitale Oekosysteme, die Wachstum unterstuetzen.",
   },
   aboutLegacy: {
      title: "Wer wir sind",
      text: "Ein kleines, agiles Team fuer schnelle, klare und leicht nutzbare Webprodukte. Wir erstellen komplette Designs und setzen sie in React oder WordPress um, mit Fokus auf Performance und SEO.",
      imageAlt: "Ueber Zotaris",
   },
   stats: {
      items: [
         ["35+", "abgeschlossene Projekte", "Websites, Plattformen, Automatisierungen und digitale Praesentationen."],
         ["120+", "automatisierte Prozesse", "Repetitive Aufgaben in klare und schnelle Workflows verwandelt."],
         ["30+", "zufriedene Kunden", "Lokale Unternehmen und wachsende Teams digital unterstuetzt."],
         ["6+", "verbundene Systeme", "CRM, Web, AI, Daten, Reports und Kommunikation in einem klaren Flow."],
      ],
   },
   concept: {
      title: "Digitales Myzel fuer moderne Unternehmen",
      text: "Wie Myzel ganze Oekosysteme in der Natur verbindet, verbindet Zotaris Prozesse, Daten und Tools zu einem kohärenten digitalen System.",
      nodes: ["Menschen", "Aufgaben", "Daten", "Kunden", "Reports", "Systeme"],
   },
   myceliumPreview: {
      eyebrow: "Digitales Myzel-Netzwerk v1.02",
      titlePrefix: "Von getrennter Arbeit zu einem ",
      titleStrong: "lebendigen digitalen System",
      titleSuffix: ".",
      text: "Druecke die Buttons, um das Konzept zu sehen: Im Chaos-Modus sind Prozesse getrennte Punkte. Im Zotaris-Modus sammeln sich Nodes zu einem verbundenen Netzwerk, und ein Klick sendet einen Puls durch das System.",
      stateLabel: "Netzwerkstatus",
      chaos: "Rohes Chaos",
      system: "Verbundenes System",
      convert: "In System umwandeln",
      pulse: "Signalpuls senden",
      core: "Intelligenz-Kern",
      online: "Online",
      fragmented: "Fragmentiert",
      routing: "Myzel-Routing-Quote",
      activePath: "Aktives optimales Pathfinding",
      disconnectedPoints: "Getrennte manuelle Punkte",
      latency: "Operationslatenz",
      synchronized: "Sofort synchronisierte Trigger",
      waiting: "Warten auf manuelle Transfers",
      quote: "Digitale Workflows sollten keine vertikalen Linien sein. Sie sind lebendige Netzwerke, die Arbeit intelligent routen.",
   },
   process: {
      title: "Wie wir arbeiten",
      text: "Ein verbundenes System, von Discovery bis Wachstum.",
      groups: { inputs: "Inputs", outputs: "Outputs", result: "Ergebnis" },
      nodes: {
         discover: { label: "Trigger", title: "Discover", assistant: "Business Analyst AI", description: "Wir verstehen, wie das Business funktioniert, welche Tools genutzt werden, wo das Team Zeit verliert und welche Prozesse Reibung erzeugen.", inputs: ["Kontext", "Ziele", "Tools", "Team"], outputs: ["Business-Ueberblick", "Pain Points", "Automatisierungsmoeglichkeiten"], result: "Ein klares Verstaendnis davon, was zuerst verbessert werden sollte." },
         audit: { label: "Audit", title: "Map", assistant: "Process Mapper AI", description: "Wir verwandeln verstreute Aufgaben in eine strukturierte Map aus Aktionen, Tools, Nutzern, Entscheidungen und Datenbewegung.", inputs: ["Signale", "Engpaesse", "Risiken"], outputs: ["Workflow-Map", "Prioritaetenliste", "Systemlogik"], result: "Der Businessprozess wird sichtbar und leichter neu aufzubauen." },
         core: { label: "Core", title: "AI Core", assistant: "Zotaris AI Core", description: "Das ist das intelligente Zentrum des Systems. Es verbindet Businesslogik, Automatisierungsregeln, Datenquellen und AI-Assistenten zu einer funktionierenden Infrastruktur.", inputs: ["Businessregeln", "Daten", "Tools", "Nutzeraktionen"], outputs: ["Verbundenes System", "Automatische Entscheidungen", "Smarte Workflows"], result: "Alles beginnt als ein verbundenes digitales System zu arbeiten." },
         build: { label: "Logik", title: "Build", assistant: "Automation Builder AI", description: "Wir bauen Automatisierungslogik, Integrationen, Dashboards, Websites, interne Tools und AI-gestuetzte Workflows.", inputs: ["Roadmap", "Flows", "Prioritaeten"], outputs: ["Automatisierungen", "Interfaces", "Integrationen"], result: "Manuelle Arbeit wird reduziert und repetitive Aufgaben werden automatisch." },
         optimize: { label: "Build", title: "Optimize", assistant: "Optimization AI", description: "Wir testen das Systemverhalten, entfernen Reibung, verbessern Geschwindigkeit, vereinfachen Aktionen und machen den Workflow verlaesslicher.", inputs: ["System", "Interfaces", "Automatisierungen"], outputs: ["Bessere Performance", "Klarere UX", "Weniger Fehler"], result: "Das System wird schneller, klarer und leichter nutzbar." },
         grow: { label: "Merge", title: "Grow", assistant: "Growth AI", description: "Das finale System ist bereit fuer mehr Kunden, mehr Daten, mehr Teammitglieder und mehr automatisierte Ablaufe.", inputs: ["Skalierung", "Metriken", "Iterationen"], outputs: ["Reports", "Skalierbare Workflows", "Wachstumsinfrastruktur"], result: "Das Business kann wachsen, ohne unnoetige manuelle Arbeit aufzubauen." },
      },
      steps: [
         ["Discover", "Wir analysieren Business, Prozesse, Engpaesse und Ziele."],
         ["Map", "Wir erstellen eine klare Map der Flows, die verbunden oder automatisiert werden muessen."],
         ["Build", "Wir entwickeln Systeme, Automatisierungen, Interfaces und Integrationen."],
         ["Optimize", "Wir testen, verfeinern und verbessern das System fuer Performance."],
         ["Grow", "Das Business bleibt mit digitaler Infrastruktur, die natuerlich wachsen kann."],
      ],
   },
   why: {
      title: "Warum Zotaris",
      text: "Zotaris fuegt nicht nur ein neues Tool hinzu. Zotaris schafft Verbindungen zwischen Tools, Menschen und Prozessen.",
      metrics: [
         ["Systemblick", "Wir betrachten dein Business als ein verbundenes System."],
         ["Gebaut fuer Wachstum", "Wir bauen klare Systeme, die mit dir wachsen koennen."],
         ["Verbundene Umsetzung", "Wir verbinden Web, AI, Automatisierung und echte Workflows."],
      ],
      points: [
         "wir sehen Business als Oekosystem",
         "wir verbinden Webentwicklung, AI, Automatisierung und Design",
         "wir bauen individuelle Loesungen",
         "wir optimieren echte Arbeit",
         "wir denken langfristig: Skalierbarkeit, Wartung, Klarheit",
      ],
   },
   team: {
      title: "Das Team hinter intelligenten digitalen Netzwerken",
      text: "Hinter jedem Zotaris System steht ein Team, das Technik, Design, Strategie und echtes Prozessverstaendnis verbindet.",
      people: [
         ["Cristian Petic", "Gruender, Mentor, CEO und Sales-Koordinator fuer Kurse und Kundengespraeche.", ["Gruender", "CEO", "Mentor", "Kurs-Sales", "Kundengespraeche"]],
         ["Daniel Diacon", "COO, Lead Developer, UI/UX Designer und Grafikdesigner.", ["COO", "Lead Developer", "UI/UX Designer", "Grafikdesigner"]],
         ["Veronica Luca", "Webentwicklerin, Webdesignerin und Managerin.", ["Webentwicklung", "Webdesign", "Management"]],
         ["Luchian Nicolae", "Freelance Manager, Koordinator fuer Kooperationen und AI-Automatisierung.", ["Freelance Manager", "Koordinator", "AI Automation"]],
         ["Sebastian Rusu", "Spezialist fuer AI-Automatisierung, Sales und externe Kooperation.", ["AI Automation", "Sales", "Externe Kooperation"]],
      ],
   },
   who: {
      title: "Ein fokussiertes Team fuer digitales Wachstum.",
      text: "Wir verbinden Design, Entwicklung, Automatisierung und Strategie, um klare digitale Workflows fuer wachsende Unternehmen zu bauen.",
      cta: "Team ansehen",
      imageAlt: "Zotaris Team",
   },
   courses: {
      title: "Praxisnahe AI- und Automatisierungskurse",
      text: "Zotaris Kurse basieren auf realen Szenarien: Task-Automation, Datenorganisation, Content-Erstellung und AI-Integration in Prozesse.",
      items: [
         ["AI fuer Business", "AI fuer Sales, Support, Content, Analyse und Produktivitaet."],
         ["Grundlagen der Automatisierung", "Repetitive Aufgaben automatisieren, ohne Prozesskontrolle zu verlieren."],
         ["Workflows mit modernen Tools", "Schnelle Systeme bauen, die echte Prozesse verbinden."],
         ["Individuelles Teamtraining", "Training angepasst an dein Unternehmen und deine Prozesse."],
      ],
   },
   faq: {
      title: "FAQ",
      items: [
         ["Was macht Zotaris genau?", "Zotaris baut Websites, Webplattformen, Automatisierungen, AI-Workflows und Systeme, die interne Prozesse verbinden. Wir starten beim realen Problem: wo Zeit verloren geht, was sich wiederholt und welche Informationen klarer zwischen Menschen, Tools und Kunden fliessen muessen."],
         ["Arbeitet ihr nur mit grossen Unternehmen?", "Nein. Wir arbeiten mit Startups, lokalen Unternehmen, wachsenden Firmen und Teams, die Arbeit automatisieren wollen. Wichtig ist ein echter Prozess, der verbessert werden kann: Sales, Support, Buchungen, Administration, Daten oder Kommunikation."],
         ["Macht ihr nur Websites?", "Nein. Websites sind nur ein Teil. Wir bauen auch Plattformen, Dashboards, interne Systeme, einfache CRMs, verbundene Formulare, Integrationen und Automatisierungen, die nach einer Anfrage weiterarbeiten."],
         ["Was bedeutet Automatisierung fuer Business?", "Automatisierung bedeutet Reduktion repetitiver Arbeit: Aufgaben, Nachrichten, Formulare, Reports, Buchungen, Benachrichtigungen, CRM und Daten. Ziel ist nicht, das Team zu ersetzen, sondern manuelle Schritte zu reduzieren und Prozesse schneller, klarer und nachvollziehbarer zu machen."],
         ["Kann ich eine komplett individuelle Loesung anfragen?", "Ja. Wir bauen Custom-Loesungen auf Basis realer Unternehmensprozesse. Wir analysieren den Flow, entscheiden was automatisiert oder gebaut werden soll und liefern eine Loesung, die mit der Zeit wachsen kann."],
      ],
   },
};

export const translations = {
   RO: {
      nav: { home: "Acasa", projects: "Proiecte", language: "Limba", top: "Sus" },
      common: { projects: "Proiecte", open: "Deschide", back: "Inapoi", backProjects: "Inapoi la proiecte", backHome: "Inapoi acasa", notFound: "Pagina nu a fost gasita.", previousService: "Serviciul precedent", nextService: "Serviciul urmator", socialLinks: "Linkuri sociale", bottomNavigation: "Navigare de jos" },
      intro: {
         titlePrefix: "Noi conectam ",
         titleSuffix: " in sisteme clare",
         accentWords: ["procese", "date", "echipe", "Fluxuri"],
         text: "Zotaris digitalizeaza businessuri prin automatizari, platforme custom, AI si strategie digitala.",
         tags: ["Digitalizare", "Automatizari", "AI workflows", "Platforme custom", "CRM", "Dashboard-uri", "UI/UX", "Web design", "Web development", "Cod custom", "Frontend", "Backend", "Integrari API", "Sisteme interne", "Consulting", "Audit digital", "Roadmap", "Cursuri AI", "Training echipe", "Sales flows", "Support flows", "Rapoarte", "Data sync", "Booking", "Product design"],
      },
      services: {
         title: "Ce facem",
         viewProjects: "Proiecte",
         cta: "Vezi serviciul",
         detail: {
            detailsTitle: "Cum transformam serviciul in sistem",
            detailsText: "Fiecare serviciu este gandit ca parte din infrastructura digitala a companiei, nu ca o livrare izolata.",
            cards: [
               ["Clarificam fluxul", "Pornim de la procesele reale, tool-urile existente si obiectivele businessului, apoi stabilim ce trebuie conectat, automatizat sau reconstruit."],
               ["Construim modular", "Livram componente clare: interfete, automatizari, integrari, date si logica de lucru, astfel incat sistemul sa ramana usor de extins."],
               ["Optimizam dupa utilizare", "Dupa lansare urmarim frictiunea, viteza si claritatea. Ajustam fluxurile pentru ca solutia sa fie folosita natural de echipa."],
            ],
            questionsTitle: "Intrebari utile",
            questionsText: "Raspunsuri scurte pentru deciziile care apar de obicei inainte sa pornim implementarea.",
            questions: [
               ["Cu ce incepem?", "Incepem cu auditul procesului: unde se pierde timp, ce se repeta si ce informatii trebuie sa circule mai clar."],
               ["Ce primesti la final?", "Primesti o solutie functionala, documentata si pregatita pentru utilizare: pagina, platforma, automatizare sau sistem conectat."],
               ["Se poate extinde mai tarziu?", "Da. Gandim fiecare livrare ca o infrastructura, nu ca un element izolat, astfel incat sa poata creste cu businessul."],
            ],
         },
         items: withServiceDetails(roServices, "RO"),
      },
      homeSections: roHome,
      footer: {
         intro: "Zotaris construieste infrastructura digitala pentru businessuri care vor procese clare, automatizari, AI workflows si platforme web scalabile.",
         services: "Servicii",
         company: "Companie",
         contact: "Contact",
         automation: "Automatizari",
         websites: "Site-uri",
         platforms: "Platforme",
         projects: "Proiecte",
         consulting: "Consultanta",
         courses: "Cursuri",
         address: "31 August 1989 St 78",
         copyright: "© 2026 zotaris.com",
      },
      contact: {
         title: "Contacteaza-ne!",
         text1: "Ai procese blocate, tool-uri separate sau munca repetitiva? Hai sa le conectam intr-un sistem clar.",
         text2: "Zotaris creeaza infrastructura digitala pentru crestere, automatizare si decizii mai bune.",
         fullName: "Nume complet", email: "Email", phone: "Numar de telefon", message: "Mesaj", sending: "Se trimite...", send: "Trimite", sent: "Mesajul a fost trimis cu succes.", error: "Mesajul nu a putut fi trimis. Incearca din nou.",
         invalid: "Completeaza numele, emailul si mesajul.",
         sendingToN8n: "Se trimite catre n8n...",
         n8nError: "Nu s-a putut trimite catre n8n. Verifica webhook-ul si CORS.",
      },
      myceliumTool: { title: "Laborator miceliu ASCII", seed: "seed", newPath: "cale noua", reset: "resetare", pause: "pauza", resume: "continua", export: "Export", exportPng: "exporta PNG curent 2x", record: "inregistreaza webm 8s", recording: "se inregistreaza...", matrixTitle: "Sisteme digitale care cresc impreuna cu businessul tau.", matrixSubtitle: "Inlocuim munca manuala imprastiata cu fluxuri inteligente si conectate.", matrixAria: "Retea ascii de miceliu digital" },
      projects: { openProject: "Vezi prezentarea", description: "Prezentare proiect", overview: "Prezentare", contribution: "Cu ce ne-am ocupat", challenges: "Dificultati", gallery: "Galerie", visitSite: "Vezi site-ul", unavailable: "Indisponibil momentan", items: makeProjects("RO") },
   },
   EN: {
      nav: { home: "Home", projects: "Projects", language: "Language", top: "Top" },
      common: { projects: "Projects", open: "Open", back: "Back", backProjects: "Back to projects", backHome: "Back home", notFound: "Page not found.", previousService: "Previous service", nextService: "Next service", socialLinks: "Social links", bottomNavigation: "Bottom navigation" },
      intro: {
         titlePrefix: "We connect ",
         titleSuffix: " into clear systems",
         accentWords: ["processes", "data", "teams", "workflows"],
         text: "Zotaris digitalizes businesses through automation, custom platforms, AI, and digital strategy.",
         tags: ["Digitalization", "Automation", "AI workflows", "Custom platforms", "CRM", "Dashboards", "UI/UX", "Web design", "Web development", "Custom code", "Frontend", "Backend", "API integrations", "Internal systems", "Consulting", "Digital audit", "Roadmap", "AI courses", "Team training", "Sales flows", "Support flows", "Reports", "Data sync", "Booking", "Product design"],
      },
      services: {
         title: "What we do",
         viewProjects: "Projects",
         cta: "View service",
         detail: {
            detailsTitle: "How we turn the service into a system",
            detailsText: "Every service is designed as part of the company digital infrastructure, not as an isolated delivery.",
            cards: [
               ["Clarify the flow", "We start from real processes, existing tools, and business goals, then define what should be connected, automated, or rebuilt."],
               ["Build modularly", "We deliver clear components: interfaces, automation, integrations, data, and working logic, so the system stays easy to extend."],
               ["Optimize after use", "After launch, we watch friction, speed, and clarity. We adjust workflows so the solution feels natural for the team."],
            ],
            questionsTitle: "Useful questions",
            questionsText: "Short answers for the decisions that usually appear before implementation starts.",
            questions: [
               ["Where do we start?", "We start with a process audit: where time is lost, what repeats, and which information should move more clearly."],
               ["What do you receive?", "You receive a working, documented solution ready for use: a page, platform, automation, or connected system."],
               ["Can it grow later?", "Yes. We treat each delivery as infrastructure, not as an isolated element, so it can grow with the business."],
            ],
         },
         items: withServiceDetails(enServices, "EN"),
      },
      homeSections: enHome,
      footer: {
         intro: "Zotaris builds digital infrastructure for businesses that want clear processes, automation, AI workflows, and scalable web platforms.",
         services: "Services",
         company: "Company",
         contact: "Contact",
         automation: "Automation",
         websites: "Websites",
         platforms: "Platforms",
         projects: "Projects",
         consulting: "Consulting",
         courses: "Courses",
         address: "31 August 1989 St 78",
         copyright: "© 2026 zotaris.com",
      },
      contact: {
         title: "Contact us!",
         text1: "Blocked processes, disconnected tools, or repetitive work? Let us connect them into a clear system.",
         text2: "Zotaris creates digital infrastructure for growth, automation, and better decisions.",
         fullName: "Full name", email: "Email", phone: "Phone number", message: "Message", sending: "Sending...", send: "Send", sent: "Your message was sent successfully.", error: "Could not send the message. Please try again.",
         invalid: "Complete your name, email, and message.",
         sendingToN8n: "Sending to n8n...",
         n8nError: "Could not send to n8n. Check the webhook and CORS.",
      },
      myceliumTool: { title: "ASCII mycelium lab", seed: "seed", newPath: "new path", reset: "reset", pause: "pause", resume: "resume", export: "Export", exportPng: "export current PNG 2x", record: "record webm 8s", recording: "recording...", matrixTitle: "Digital systems that grow with your business.", matrixSubtitle: "We replace scattered manual work with intelligent, connected workflows.", matrixAria: "Digital mycelium ascii network" },
      projects: { openProject: "View presentation", description: "Project presentation", overview: "Overview", contribution: "What we handled", challenges: "Challenges", gallery: "Gallery", visitSite: "Visit website", unavailable: "Unavailable for now", items: makeProjects("EN") },
   },
   DE: {
      nav: { home: "Start", projects: "Projekte", language: "Sprache", top: "Nach oben" },
      common: { projects: "Projekte", open: "Oeffnen", back: "Zurueck", backProjects: "Zurueck zu Projekten", backHome: "Zurueck zur Startseite", notFound: "Seite nicht gefunden.", previousService: "Vorheriger Service", nextService: "Naechster Service", socialLinks: "Social Links", bottomNavigation: "Untere Navigation" },
      intro: {
         titlePrefix: "Wir verbinden ",
         titleSuffix: " zu klaren Systemen",
         accentWords: ["Prozesse", "Daten", "Teams", "Workflows"],
         text: "Zotaris digitalisiert Unternehmen durch Automatisierung, Custom-Plattformen, AI und digitale Strategie.",
         tags: ["Digitalisierung", "Automatisierung", "AI Workflows", "Custom-Plattformen", "CRM", "Dashboards", "UI/UX", "Webdesign", "Webentwicklung", "Custom Code", "Frontend", "Backend", "API-Integrationen", "Interne Systeme", "Consulting", "Digital Audit", "Roadmap", "AI-Kurse", "Team Training", "Sales Flows", "Support Flows", "Reports", "Data Sync", "Booking", "Product Design"],
      },
      services: {
         title: "Was wir machen",
         viewProjects: "Projekte",
         cta: "Service ansehen",
         detail: {
            detailsTitle: "Wie wir den Service in ein System verwandeln",
            detailsText: "Jeder Service wird als Teil der digitalen Infrastruktur des Unternehmens gedacht, nicht als isolierte Lieferung.",
            cards: [
               ["Flow klaeren", "Wir starten mit realen Prozessen, bestehenden Tools und Business-Zielen und definieren, was verbunden, automatisiert oder neu gebaut werden sollte."],
               ["Modular bauen", "Wir liefern klare Komponenten: Interfaces, Automatisierung, Integrationen, Daten und Arbeitslogik, damit das System leicht erweiterbar bleibt."],
               ["Nach Nutzung optimieren", "Nach dem Launch beobachten wir Reibung, Geschwindigkeit und Klarheit. Wir passen Workflows an, damit die Loesung natuerlich genutzt wird."],
            ],
            questionsTitle: "Nuetzliche Fragen",
            questionsText: "Kurze Antworten auf Entscheidungen, die meistens vor der Umsetzung entstehen.",
            questions: [
               ["Womit starten wir?", "Wir starten mit einem Prozessaudit: wo Zeit verloren geht, was sich wiederholt und welche Informationen klarer fliessen muessen."],
               ["Was bekommst du am Ende?", "Du bekommst eine funktionierende, dokumentierte Loesung: Seite, Plattform, Automatisierung oder verbundenes System."],
               ["Kann es spaeter wachsen?", "Ja. Wir denken jede Lieferung als Infrastruktur, nicht als isoliertes Element, damit sie mit dem Business wachsen kann."],
            ],
         },
         items: withServiceDetails(deServices, "DE"),
      },
      homeSections: deHome,
      footer: {
         intro: "Zotaris baut digitale Infrastruktur fuer Unternehmen, die klare Prozesse, Automatisierung, AI-Workflows und skalierbare Webplattformen wollen.",
         services: "Services",
         company: "Unternehmen",
         contact: "Kontakt",
         automation: "Automatisierung",
         websites: "Websites",
         platforms: "Plattformen",
         projects: "Projekte",
         consulting: "Beratung",
         courses: "Kurse",
         address: "31 August 1989 St 78",
         copyright: "© 2026 zotaris.com",
      },
      contact: {
         title: "Kontakt!",
         text1: "Blockierte Prozesse, getrennte Tools oder repetitive Arbeit? Wir verbinden sie zu einem klaren System.",
         text2: "Zotaris schafft digitale Infrastruktur fuer Wachstum, Automatisierung und bessere Entscheidungen.",
         fullName: "Vollstaendiger Name", email: "Email", phone: "Telefonnummer", message: "Nachricht", sending: "Wird gesendet...", send: "Senden", sent: "Deine Nachricht wurde erfolgreich gesendet.", error: "Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.",
         invalid: "Bitte Name, Email und Nachricht ausfuellen.",
         sendingToN8n: "Wird an n8n gesendet...",
         n8nError: "Konnte nicht an n8n senden. Pruefe Webhook und CORS.",
      },
      myceliumTool: { title: "ASCII-Myzel-Labor", seed: "seed", newPath: "neuer Pfad", reset: "zuruecksetzen", pause: "Pause", resume: "fortsetzen", export: "Export", exportPng: "aktuelles PNG 2x exportieren", record: "webm 8s aufnehmen", recording: "Aufnahme...", matrixTitle: "Digitale Systeme, die mit deinem Business wachsen.", matrixSubtitle: "Wir ersetzen verstreute manuelle Arbeit durch intelligente, verbundene Workflows.", matrixAria: "ASCII-Netzwerk aus digitalem Myzel" },
      projects: { openProject: "Praesentation ansehen", description: "Projektpraesentation", overview: "Ueberblick", contribution: "Unser Beitrag", challenges: "Herausforderungen", gallery: "Galerie", visitSite: "Website besuchen", unavailable: "Derzeit nicht verfuegbar", items: makeProjects("DE") },
   },
};
